module.exports = __webpack_public_path__ + "img/461169d29a3f0ca35491194cb09b4d56.806f2988.jpg";